/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_LegalInputs */

const en_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const zh_hans1_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法律`)
};

const pt_br2_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurídico`)
};

const es_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const fr_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentions légales`)
};

const de_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtliches`)
};

const ru_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правовая информация`)
};

const it_footer_legal = /** @type {(inputs: Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note legali`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Footer_LegalInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_legal = /** @type {((inputs?: Footer_LegalInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_LegalInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_legal(inputs)
	if (locale === "pt-BR") return pt_br2_footer_legal(inputs)
	if (locale === "es") return es_footer_legal(inputs)
	if (locale === "fr") return fr_footer_legal(inputs)
	if (locale === "de") return de_footer_legal(inputs)
	if (locale === "ru") return ru_footer_legal(inputs)
	if (locale === "it") return it_footer_legal(inputs)
	return en_footer_legal(inputs)
});